module.exports = __webpack_public_path__ + "img/accessory_hat_07.2b72d299.svg";